import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiIcon, UiSelect } from 'ui-components';
import {
  CUSTOMER_LABELS,
  getCustomerLabelConfig,
} from '../../constants/customerLabels';
import {
  StyledCustomerLabelFilter,
  StyledMenuItem,
} from './CustomerLabelFilter.styles';

const ALL = 'all';

function CustomerLabelFilter({ value = [], onChange }) {
  const { t } = useTranslation();

  const handleChange = (event) => {
    const next = event.target.value;
    onChange(next.includes(ALL) ? [] : next);
  };

  const renderValue = (selected) => {
    if (!selected.length) {
      return (
        <span className='placeholder'>
          {t('users:customerLabel.filterPlaceholder')}
        </span>
      );
    }

    return selected
      .map((item) => {
        const config = getCustomerLabelConfig(item);
        return config ? t(config.labelKey) : item;
      })
      .join('، ');
  };

  return (
    <StyledCustomerLabelFilter>
      <UiSelect
        multiple
        displayEmpty
        value={value}
        onChange={handleChange}
        renderValue={renderValue}
      >
        <StyledMenuItem value={ALL}>{t('common:all')}</StyledMenuItem>

        {CUSTOMER_LABELS.map((item) => (
          <StyledMenuItem key={item.value} value={item.value}>
            <UiIcon src={item.icon} width={18} height={18} className='ml-8' />
            {t(item.labelKey)}
          </StyledMenuItem>
        ))}
      </UiSelect>
    </StyledCustomerLabelFilter>
  );
}

CustomerLabelFilter.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

export default CustomerLabelFilter;
